// This file is used for the listings gallery on the single listing page.
export default {};
